// Rodzaj rozgrywek (`competition_type` z backendu — service._competition_type):
// sparing | liga | puchar | europa | inne. Kolejność + etykiety trzymane w jednym
// miejscu, bo filtruje po nich i lista meczów, i karta zawodnika.

export const COMPETITION_TYPE_ORDER = ['liga', 'puchar', 'sparing', 'europa', 'inne'] as const

export const COMPETITION_TYPE_LABEL: Record<string, string> = {
  liga: 'Liga',
  puchar: 'Puchar',
  sparing: 'Sparing',
  europa: 'Europa',
  inne: 'Inne',
}

/** Mecz towarzyski — jedyny typ domyślnie WYŁĄCZONY na karcie zawodnika. */
export const FRIENDLY_TYPE = 'sparing'

/** Rozgrywki ligowe — jedyny typ domyślnie WŁĄCZONY na listach meczów i LIVE. */
export const LEAGUE_TYPE = 'liga'

/** Wszystko poza ligą — domyślny zestaw ukrytych typów na tych listach. */
export const NON_LEAGUE_TYPES: readonly string[] =
  COMPETITION_TYPE_ORDER.filter((t) => t !== LEAGUE_TYPE)

/** Puchar krajowy — mecz o stawkę rozgrywany OBOK ligi (środek tygodnia). */
export const CUP_TYPE = 'puchar'

/** Puchary europejskie — jak puchar krajowy: o stawkę, obok ligi. */
export const EUROPE_TYPE = 'europa'

export const competitionTypeLabel = (t: string): string => COMPETITION_TYPE_LABEL[t] ?? t
